import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "@velaro/velaro-component-lib";
import React from "react";
import { FieldDefinition } from ".";
import FieldForm, { defaultfieldModel } from "./FieldForm";

interface Props {
  show: boolean;
  onCancel(): void;
  submit(definition: FieldDefinition): void;
}

export default function CreateFieldModal(props: Props) {
  const [field, setField] = React.useState<FieldDefinition>(defaultfieldModel);

  return (
    <Modal show={props.show}>
      <ModalHeader title="Add Field" onClose={() => props.onCancel()} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.submit(field);
          setField(defaultfieldModel);
        }}
      >
        <ModalBody>
          <div className="p-4">
            <FieldForm
              field={field}
              onChange={(updates) => {
                setField((oldState) => ({ ...oldState, ...updates }));
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="p-4 flex">
            <div className="ml-auto">
              <button
                type="button"
                onClick={props.onCancel}
                className="btn-link mr-2"
              >
                Cancel
              </button>
              <button type="submit" className="btn-green">
                Continue
              </button>
            </div>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}
